import { z } from "zod";

export const loginSchema = z.object({
  emailAddress: z.string().min(1, "Email Address is required"),
  password: z.string().min(6, "Password must be at least 6 characters"),
  remember: z.boolean().optional(),
});
export const addCreditsSchema = z.object({
  // The number input yields a string; coerce so the resolver hands back a number.
  credits: z.coerce
    .number({ invalid_type_error: "Credits must be a number" })
    .int("Credits must be a whole number")
    .positive("Credits must be greater than 0")
    .max(10000, "Cannot add more than 10000 credits at once"),
  source: z.string().max(60, "Reason must be 60 characters or fewer").optional(),
});
export const templateSchema = z.object({
  name: z.string().min(1, "Name can't be blank"),
  templateCode: z.string().min(1, "Tempate code can't be blank"),
  subject: z.string().min(1, "Subject can't be blank"),
  body: z.string().min(1, "Body can't be blank"),
});
export const blogSchema = z.object({
  title: z.string().min(1, "Title can't be blank"),
  content: z.string().min(1, "Content can't be blank"),
  metaData: z.array(z.string()).optional(),
  metaDescription: z.string().min(1, "Meta Description can't be blank"),
  metaTitle: z.string().min(1, "Meta Title can't be blank"),
  description: z.string().min(1, "Description can't be blank"),
  name: z.string().min(1, "Name can't be blank"),
});

export const cityPageSchema = z.object({
  city: z.string().min(1, "City name can't be blank"),
  country: z.string().min(1, "Country can't be blank"),
  countrySlug: z.string().min(1, "Country slug can't be blank"),
  slug: z.string().optional(),
  metaTitle: z.string().min(1, "Meta title can't be blank"),
  metaDescription: z.string().min(1, "Meta description can't be blank"),
  metaKeywords: z.string().optional(),
  canonicalUrl: z.string().optional(),
  ogImage: z.string().optional(),
  status: z.number().optional(),

  hero: z.any().optional(),
  trustItems: z.array(z.any()).optional(),
  spotsHeader: z.any().optional(),
  spots: z.array(z.any()).optional(),
  why: z.any().optional(),
  vibesHeader: z.any().optional(),
  vibes: z.array(z.any()).optional(),
  cta: z.any().optional(),
  faqHeader: z.any().optional(),
  faqs: z.array(z.any()).optional(),
  nearbyHeader: z.any().optional(),
  nearbyCities: z.array(z.any()).optional(),
});
export const notificationSchema = z.object({
  name: z.string().min(1, "ame can't be blank"),
  notificationCode: z.string().min(1, "Notification code can't be blank"),
  title: z.string().min(1, "Title can't be blank"),
  message: z.string().min(1, "Message can't be blank"),
});
export const newsSchems = z.object({
  name: z.string().min(1, "name can't be blank"),
  heading: z.string().min(1, "heading can't be blank"),
  body: z.string().min(1, "Body can't be blank"),
});

export const listItemSchema = z.object({
  label: z.string().optional(),
  value: z.string().optional(),
});
export const parameterSchema =
  z.object({
    name: z.string().min(1, "name can't be blank"),
    parameterCode: z.string().min(1, "Tempate code can't be blanl"),
    parameterType: z.string().min(1, "Parameter type can't be blank"),
    parameterValue: z.string().optional(),
    parameterList: z.array(listItemSchema).optional(), // <-- Include this if you're using it separately in the form

  });

export const customerSchema = z.object({
  userName: z.string().min(1, "User Name is required"),
  emailAddress: z.string().email("Invalid email").min(1),
  dateOfBirth: z.date().optional(),
  country: z.string().min(1, "Country is required"),
  city: z.string().min(1, "City is required"),
  state: z.string().optional(),
  gender: z.string().min(1, "Gender is required"),
  interestedGender: z.array(z.string()).optional(),

  dateCreated: z.date().optional(),
  status: z.string().min(1, "Status is required"),

  mpin: z.number().optional(),
  pinCode: z.string().optional(),

  children: z.string().optional(),
  smoking: z.string().optional(),
  lastActivity: z.date().optional(),
  sexualPractice: z.array(z.string()).optional(),
  relationshipType: z.string().optional(),
  sports: z.array(z.string()).optional(),
  hobbies: z.array(z.string()).optional(),
  income: z.string().optional(),
  eyeColor: z.string().optional(),
  personality: z.string().optional(),
  ethnicity: z.string().optional(),
  introduction: z.string().optional(),
  height: z.string().optional(),
  occupation: z.string().optional(),
  profileImage: z.string().optional(),
  maritalStatus: z.string().optional(),
  sexualOriantation: z.string().optional(),
  bodyShape: z.string().optional(),

  enableMpin: z.boolean().optional(),
  emailAlert: z.boolean().optional(),
  verified: z.boolean().optional(),
  online: z.boolean().optional(),

  lookingFor: z.string().optional(),
  kids: z.string().optional(),
  education: z.string().optional(),
  religion: z.string().optional(),
  drinking: z.string().optional(),

  diet: z.array(z.string()).optional(),
  fitness: z.string().optional(),
  pets: z.array(z.string()).optional(),
  relaxAndSocial: z.array(z.string()).optional(),
  entertainment: z.array(z.string()).optional(),
  foodAndDrinks: z.array(z.string()).optional(),
  travel: z.array(z.string()).optional(),
  desires: z.array(z.string()).optional(),
  funGames: z.array(z.string()).optional(),
});


export const roleSchema = z.object({
  name: z.string().min(1, "name can't be blank"),
  description: z.string().min(1, "Description code can't be blank"),
  status: z.string().min(1, "Status can't be blank"),
  // Role-level, not part of the per-screen view/edit matrix. Grants access to a
  // user's private gallery, so it is deliberately a separate opt-in.
  isSuperAdmin: z.boolean().optional(),
});
export const userSchema = z.object({
  firstName: z.string().min(1, "First Name can't be blank"),
  lastName: z.string().min(1, "Last Name code can't be blank"),
  emailAddress: z.string().email("Invalid Email"),
  roleID: z.string().min(1, "Role can't be blank"),
  status: z.string().min(1, "Status can't be blank"),
});

export const sendNotification = z.object({
  title: z.string().min(1, "Title can't be blank"),
  message: z.string().min(1, "Message  can't be blank"),
  notificationCode: z.string(),
  isBulk: z.boolean(),
  isTemplate: z.boolean(),
});


export const creditPackageSchema = z.object({
  pack: z.coerce.number({ invalid_type_error: "Pack is required" }).min(1, "Pack must be at least 1"),
  credits: z.coerce.number({ invalid_type_error: "Credits is required" }).min(1, "Credits must be at least 1"),
  price: z.coerce.number({ invalid_type_error: "Price is required" }).min(1, "Price must be at least 1"),
  displayOrder: z.coerce.number().optional(),
  status: z.enum(["active", "inactive"]).optional(),
});

export const sendEmail = z.object({
  subject: z.string().min(1, "Subject can't be blank"),
  body: z.string().min(1, "Body can't be blank"),
  templateCode: z.string(),
  emails: z.array(z.string()).optional(),
  isBulk: z.boolean(),
  isTemplate: z.boolean(),
  smtp: z.string().min(1, 'SMTP is required')
});